/* int-l4-sr-cards.js: moved verbatim from snippets/int-sr-cards.liquid (pdp-html-weight lever 4, 2026-11-02). Do not edit here without the source note. */
document.addEventListener('DOMContentLoaded', function () {
(function(){
  function init(root){
    if(root.dataset.srInit) return; root.dataset.srInit='1';
    var list=root.querySelector('.int-sr__list'); if(!list) return;
    var items=[].slice.call(list.children);
    var more=root.getAttribute('data-more')||'Read more';
    items.forEach(function(li){
      var body=li.querySelector('.int-sr__body');
      var b=document.createElement('button');
      b.type='button'; b.className='int-sr__more'; b.textContent=more; b.setAttribute('aria-expanded','false');
      b.addEventListener('click',function(){li.classList.add('is-open');b.setAttribute('aria-expanded','true');});
      li.appendChild(b);
      var tr=li.querySelector('.int-sr__body--tr,.int-sr__body--orig');
      if(tr || (body && body.scrollHeight>body.clientHeight+2)) li.classList.add('has-more');
    });
    var nav=root.querySelector('.int-sr__nav'), dots=root.querySelector('.int-sr__dots');
    var prev=root.querySelector('.int-sr__arrow--prev'), next=root.querySelector('.int-sr__arrow--next');
    var built=-1;
    function step(){var a=items[0],b2=items[1];return a?(b2?b2.offsetLeft-a.offsetLeft:a.offsetWidth):list.clientWidth;}
    function update(){
      var over=list.scrollWidth>list.clientWidth+2;
      root.classList.toggle('is-scrollable',over);
      var s=step()||1, vis=Math.max(1,Math.round(list.clientWidth/s)), pos=Math.max(1,items.length-vis+1);
      if(pos!==built){dots.innerHTML='';for(var i=0;i<pos;i++){var d=document.createElement('span');d.className='int-sr__dot';dots.appendChild(d);}built=pos;}
      var max=list.scrollWidth-list.clientWidth-2;
      var idx=list.scrollLeft>=max?pos-1:Math.min(pos-1,Math.round(list.scrollLeft/s));
      [].forEach.call(dots.children,function(d,j){d.classList.toggle('is-on',j===idx);});
      if(prev) prev.disabled=list.scrollLeft<=2;
      if(next) next.disabled=list.scrollLeft>=max;
    }
    if(prev) prev.addEventListener('click',function(){list.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){list.scrollBy({left:step(),behavior:'smooth'});});
    var t; list.addEventListener('scroll',function(){cancelAnimationFrame(t);t=requestAnimationFrame(update);},{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function run(){[].forEach.call(document.querySelectorAll('#int-reviews .int-sr'),init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();
});
